import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './layout/main/main.component';
import { HomepageComponent } from './login/homepage/homepage.component';

const routes: Routes = [
  {
    path : '',
    redirectTo : '/accueil',
    pathMatch:'full'
  },
  {path : 'accueil', component : HomepageComponent},
  {
    path : 'registration',
    loadChildren : () => import('./registration/registration.module').then(m => m.RegistrationModule)
  },
  {
    path : 'presentation',
    loadChildren : () => import('./presentation/presentation.module').then(m => m.PresentationModule) 
  },
  {path : '', component : MainComponent, children:[
    {
      path : 'follow',
      loadChildren : () => import('./follow/follow.module').then(m => m.FollowModule) 
    },
    {
      path : 'profil',
      loadChildren : () => import('./profil/profil.module').then(m => m.ProfilModule) 
    },
    {
      path : 'project',
      loadChildren : () => import('./project-management/project-management.module').then(m => m.ProjectManagementModule) 
    },
    {
      path : 'recruit',
      loadChildren : () => import('./recruit/recruit.module').then(m => m.RecruitModule)
    },
  ]},
  {path: '**', redirectTo: 'accueil'},

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
